module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-162.22c3d6e1.jpg";